/**
 * แม่แบบรายงานการติดตั้ง EV Charger แยกตามค่ายรถ (ย้ายจาก lib/evTemplates.js ของระบบเดิม — พิกัดคัดลอกตรงตัว ห้ามแก้)
 *
 * พิกัดทั้งหมดวัดจากไฟล์ฟอร์มจริง (apps/server/assets/ev/*.pdf) ด้วยหน่วย pt โดยนับ y จาก "ขอบบน" ของหน้า
 * (pdf-lib นับจากขอบล่าง — ตัวแปลงอยู่ใน apps/server/src/lib/ev-pdf.ts) เพื่อให้อ่านเทียบกับฟอร์มที่พิมพ์ออกมาได้ตรงๆ
 *
 * หน้าในแม่แบบ OMODA: 1=ปกลูกค้า/เซ็น 2=รูปยืนยัน 3=สเปกไฟฟ้า 4=หัวข้อรูป1-3 5=หัวข้อรูป4-6
 * (หน้า 6-7 ในไฟล์ต้นฉบับเป็นสำเนาหน้า 4-5 ไว้เผื่อรูปล้น — ระบบนี้ไม่ใช้ เพราะสร้างหน้าเพิ่มเองแล้วรันเลขหน้าให้ถูก)
 *
 * core ไม่แตะไฟล์ — `formPdf` / `packageDoc.image` เป็นแค่ชื่อไฟล์ใน assets/ev ฝั่ง server เป็นคนหาไฟล์เอง
 */
// ระยะกึ่งกลางช่องติ๊ก: ตัวอักษร ☐ ในฟอร์มกว้าง ~10.4 pt สูง ~13 pt นับจากมุมซ้ายบนของ span
const BOX_DX = 5.2;
const BOX_DY = 7.0;
const box = (x, y) => ({ cx: x + BOX_DX, cy: y + BOX_DY });
export const OMODA_JAECOO = {
    key: 'OMODA_JAECOO',
    label: 'OMODA & JAECOO',
    brandLine: 'OMODA & JAECOO (Thailand) Co., Ltd.',
    formPdf: 'OMODA_JAECOO.pdf',
    page: { width: 612, height: 792 },
    // index หน้าในไฟล์แม่แบบ (0-based)
    templatePages: { cover: 0, confirm: 1, spec: 2, photos: 3 },
    // ---------- หน้า 1: ข้อมูลลูกค้า ----------
    // คอลัมน์ตาราง (จากเส้นตารางจริง): 36 | 149.1 | 305.7 | 411.9 | 575.5
    cover: {
        fields: {
            installDate: { x: 421, y: 82.5, w: 152, size: 11 },
            jobNo: { x: 153, y: 99.0, w: 150, size: 11 },
            custNo: { x: 421, y: 99.0, w: 152, size: 11 },
            customerName: { x: 153, y: 115.5, w: 150, size: 11 },
            phone: { x: 421, y: 115.5, w: 152, size: 11 },
            address: { x: 153, y: 132.0, w: 420, size: 11 },
            vin: { x: 153, y: 205.0, w: 150, size: 11 },
            serialNo: { x: 421, y: 205.0, w: 152, size: 11 },
            suggestion: { x: 153, y: 276.0, w: 420, size: 10 },
        },
        // ชื่อ/เบอร์ผู้ให้บริการติดตั้ง — พิมพ์ไว้เหนือเส้น Date ในช่องเซ็นฝั่งซ้าย
        installer: {
            nameCenterX: 172, nameY: 706, nameSize: 11,
            phoneCenterX: 172, phoneY: 719, phoneSize: 10,
        },
        checkboxes: {
            region: {
                'กทม.': box(154.7, 140.1),
                'ปริมณฑล': box(192.9, 140.1),
                'ตจว.': box(245.9, 140.1),
            },
            siteType: {
                'บ้านเดี่ยว': box(154.7, 159.1),
                'บ้านแฝด': box(207.1, 159.1),
                'อาคารพาณิชย์': box(257.4, 159.1),
                'โชว์รูม': box(326.5, 159.1),
                'ตึกแถว': box(369.1, 159.1),
                'โรงงาน': box(413.8, 159.1),
                'คอนโด': box(154.7, 177.5),
                'อพาร์ทเม้นท์': box(198.6, 177.5),
                'สำนักงาน': box(261.5, 177.5),
                'อื่น ๆ': box(315.0, 177.5),
            },
            // ลูกค้าติ๊กเองหน้างาน — วาดให้เฉพาะกรณีกรอกย้อนหลังในระบบ
            scoreQuality: [box(154.7, 229.4), box(215.5, 229.4), box(268.2, 229.4), box(320.6, 229.4), box(400.9, 229.4)],
            scoreService: [box(154.7, 248.3), box(215.5, 248.3), box(268.2, 248.3), box(320.6, 248.3), box(400.9, 248.3)],
        },
        siteTypeOtherText: { x: 375, y: 189, w: 130, size: 10 },
    },
    // ---------- หน้า 3: สเปกไฟฟ้า ----------
    // แต่ละ option = ช่องติ๊ก, ถ้ามี fill = ตำแหน่งเติมตัวเลขบนเส้นประ
    spec: {
        rows: [
            {
                key: 'meterType', label: 'ขนาดมิเตอร์เดิมของสถานที่ติดตั้ง / Meter type', multi: false,
                options: [
                    { value: '1 เฟส 15/45', ...box(261.4, 81.4) },
                    { value: '1 เฟส 30/100', ...box(356.7, 81.4) },
                    { value: '3 เฟส 15/45', ...box(261.4, 97.7) },
                    { value: '3 เฟส 30/100', ...box(356.7, 97.7) },
                    { value: 'อื่น ๆ', ...box(441.4, 97.7), fill: { x: 505, y: 108.5, w: 66, size: 9 } },
                ],
            },
            {
                key: 'needNewMeter', label: 'จำเป็นจะต้องขอมิเตอร์ใหม่หรือเพิ่มขนาดมิเตอร์หรือไม่', multi: false,
                options: [
                    { value: 'ใช่', ...box(261.4, 114.5) },
                    { value: 'ไม่ใช่', ...box(310.3, 114.5) },
                ],
            },
            {
                key: 'newMeterSize', label: 'ขนาดมิเตอร์ใหม่ที่ขอ', multi: false,
                options: [
                    { value: '1 เฟส 15(45)A', ...box(354.7, 130.7) },
                    { value: '1 เฟส 30(100)A', ...box(407.7, 130.7) },
                    { value: '3 เฟส 15(45)A', ...box(357.4, 147.0) },
                    { value: '3 เฟส 30(100)A', ...box(412.9, 147.0) },
                    { value: 'อื่นๆ', ...box(261.4, 163.2), fill: { x: 330, y: 174.0, w: 230, size: 9 } },
                ],
            },
            {
                key: 'mainBreaker', label: 'ขนาดอุปกรณ์ตัดตอนหลักของสถานที่ติดตั้ง / Main Breaker rate', multi: false,
                options: [
                    { value: '1 เฟส', ...box(261.4, 180.0), fill: { x: 336, y: 190.8, w: 40, size: 9 } },
                    { value: '3 เฟส', ...box(390.1, 180.0), fill: { x: 462, y: 190.8, w: 34, size: 9 } },
                    { value: 'อื่น ๆ', ...box(261.4, 196.3), fill: { x: 328, y: 207.1, w: 230, size: 9 } },
                ],
            },
            {
                key: 'meterToConsumer', label: 'ระยะสายไฟ จากจุดติดตั้งมิเตอร์ ถึงตู้ consumer', multi: false,
                options: [
                    { value: '1 เฟส', ...box(261.4, 213.1), fill: { x: 340, y: 223.9, w: 74, size: 9 } },
                    { value: '3 เฟส', ...box(261.4, 229.4), fill: { x: 340, y: 240.2, w: 74, size: 9 } },
                ],
            },
            {
                key: 'groundSystem', label: 'ระบบสายกราวด์/สายดินเดิม', multi: false,
                options: [
                    { value: 'ผ่าน', ...box(261.4, 246.1) },
                    { value: 'ไม่ผ่าน (ต้องติดตั้งใหม่)', ...box(333.4, 246.1) },
                ],
            },
            {
                key: 'toGroundBox', label: 'ระยะสายไฟจากจุดติดตั้ง ถึงตู้ G', multi: false,
                options: [
                    { value: 'สายกราวด์', ...box(261.4, 262.9), fill: { x: 350, y: 273.7, w: 74, size: 9 } },
                ],
            },
            {
                key: 'spareCircuit', label: 'ช่องว่างสำหรับใส่เบรกเกอร์ลูกย่อยภายในตู้ของลูกค้า / Spare circuit', multi: false,
                options: [
                    { value: 'มี', ...box(261.4, 279.6) },
                    { value: 'ไม่มี', ...box(333.4, 279.6) },
                ],
            },
            {
                key: 'wiringLength', label: 'ระยะสายจากตู้โหลดไฟฟ้าหรือมิเตอร์ไปยังสถานที่ติดตั้ง', multi: false,
                freeText: { x: 290, y: 322.6, w: 100, size: 9 },
                options: [],
            },
            {
                key: 'wiringCondition', label: 'รูปแบบการเดินสาย / Wiring condition', multi: true,
                options: [
                    { value: 'เดินท่อ PVC', ...box(261.4, 344.6), fill: { x: 340, y: 355.4, w: 48, size: 9 } },
                    { value: 'เดินท่อ EMT', ...box(369.4, 344.6), fill: { x: 449, y: 355.4, w: 48, size: 9 } },
                    { value: 'เดินท่อ IMC', ...box(261.4, 360.8), fill: { x: 338, y: 371.6, w: 48, size: 9 } },
                    { value: 'เดินท่อ HDPE', ...box(388.5, 360.8), fill: { x: 470, y: 371.6, w: 48, size: 9 } },
                    { value: 'ขุดดิน', ...box(261.4, 377.1), fill: { x: 310, y: 387.9, w: 48, size: 9 } },
                    { value: 'กรีดพื้นคอนกรีต (แนวนอน)', ...box(395.3, 377.1), fill: { x: 480, y: 387.9, w: 48, size: 9 } },
                    { value: 'กรีดพื้นคอนกรีต', ...box(261.4, 393.3), fill: { x: 346, y: 404.1, w: 48, size: 9 } },
                    { value: 'cable rack', ...box(261.4, 409.7), fill: { x: 425, y: 420.5, w: 48, size: 9 } },
                    { value: 'เก็บฝ้า', ...box(261.4, 425.9), fill: { x: 310, y: 436.7, w: 48, size: 9 } },
                    { value: 'อื่น ๆ', ...box(261.4, 442.2), fill: { x: 330, y: 453.0, w: 220, size: 9 } },
                ],
            },
            {
                key: 'specialComponents', label: 'อุปกรณ์เพิ่มเติม / Special components', multi: false,
                options: [
                    { value: 'ไม่มี', ...box(261.4, 458.9) },
                    { value: 'มี', ...box(264.0, 475.2), fill: { x: 345, y: 486.0, w: 215, size: 9 } },
                ],
            },
        ],
    },
    // ---------- หน้า 2: รูปยืนยันงานติดตั้ง (4 ช่อง ในกรอบ 42.8,96.1 - 567.8,687.8) ----------
    confirm: {
        slots: [
            { key: 'vin_plate', caption: 'รูปหมายเลขตัวถัง (VIN)', rect: { x: 52, y: 106, w: 244, h: 254 } },
            { key: 'charger_sn', caption: 'รูปหมายเลขเครื่องชาร์จ Serial No.', rect: { x: 314, y: 106, w: 244, h: 254 } },
            { key: 'handover', caption: 'รูปส่งงาน ถ่ายหน้าจุดติดตั้ง', rect: { x: 52, y: 401, w: 244, h: 226 } },
            { key: 'vehicle', caption: 'รูปรถให้เห็นรุ่น (ยี่ห้อ)', rect: { x: 314, y: 401, w: 244, h: 226 } },
        ],
    },
    // ---------- หน้ารูปหน้างาน ----------
    // สร้างจากการก๊อปหน้า 4 ของแม่แบบ (ได้ header/logo/footer มาครบ) แล้วลบเนื้อหาเดิมทิ้ง เขียนหัวข้อ+รูปเอง
    photoPage: {
        clearRect: { x: 30, y: 66, w: 552, h: 674 }, // ทับหัวข้อเดิมของแม่แบบด้วยสีขาว
        pageNoRect: { x: 540, y: 750, w: 44, h: 20 }, // ทับ "Page | 4" เดิม
        pageNoRight: 578.2, pageNoY: 766.5, pageNoSize: 10,
        contentTop: 71.4,
        contentBottom: 736,
        headingSize: 11,
        headingGap: 6, // ระยะจากบรรทัดหัวข้อถึงรูปแถวแรก
        sectionGap: 14, // ระยะระหว่างท้ายรูปของหัวข้อหนึ่งกับหัวข้อถัดไป
        grid: {
            cellW: 100.8, cellH: 134.4, // 3:4 เท่าฟอร์มจริง
            colGap: 4.2, rowGap: 4.1,
            cols: 5,
            marginLeft: 34.5,
        },
    },
    // ผู้ให้บริการติดตั้งเป็นคนเดิมทุกงาน จึงไม่ทำเป็นช่องกรอกในหน้าเว็บให้ต้องพิมพ์ซ้ำทุกครั้ง
    // **เปลี่ยนคนหรือเบอร์ = แก้ 2 บรรทัดนี้ที่เดียว** แล้วรายงานที่สร้างใหม่จะใช้ค่าใหม่ทันที
    // (รายงานเก่าเก็บค่าที่ใช้ตอนนั้นไว้ในตัวรายงานแล้ว ไม่เปลี่ยนย้อนหลัง — ใบที่ปริ้นไปแล้วจึงยังตรงกับที่เซ็น)
    defaultInstaller: {
        name: 'เศรษฐวุฒิ พัฒนวัฒไพศาล',
        phone: '092-698-8778',
    },
    // ---------- ใบรับทราบแพ็กเกจ (OJ Charger Installation Package R4.0) ----------
    // อาร์ตเวิร์กเปล่าเป็น JPG 905x1280 px จากค่ายรถ วางเต็มหน้า A4 (อัตราส่วนตรงกันพอดี)
    // พิกัดด้านล่างเป็น pt บนหน้า A4 นับจากขอบบน — พิมพ์เฉพาะฝั่ง "ศูนย์บริการผู้ให้ข้อมูล"
    // ส่วนฝั่งลูกค้าและช่องลงชื่อทั้งสองฝั่ง เว้นว่างให้เซ็นมือหน้างานตามระเบียบเดิม
    packageDoc: {
        image: 'OMODA_JAECOO-package.jpg',
        pageWidth: 595.28,
        pageHeight: 841.89,
        fields: {
            installerName: { x: 253, y: 787, w: 122, size: 10 },
            installerPhone: { x: 253, y: 801, w: 122, size: 10 },
            date: { x: 246, y: 827, w: 114, size: 10 },
        },
    },
    // ---------- หัวข้อรูป ----------
    confirmSlots: ['vin_plate', 'charger_sn', 'handover', 'vehicle'],
    sections: [
        { no: 1, key: 'dress_code', min: 3, title: '1.เครื่องแต่งกายในการเข้าปฏิบัติหน้างาน (Safety vest + รองเท้าหุ้มส้น) ถ่ายหน้าบ้านลูกค้าแบบเต็มตัว /เลขข้างเครื่องชาร์จ (Serial No.)/ลูกค้ารับการ์ด', short: 'เครื่องแต่งกาย + หน้าบ้านลูกค้า + ลูกค้ารับการ์ด' },
        { no: 2, key: 'load_center', min: 2, title: '2.จุดโหลดไฟฟ้า ตู้โหลดเซนเตอร์ หลังติดตั้ง Breaker ลูกย่อย', short: 'ตู้โหลดเซนเตอร์ หลังติดตั้ง Breaker' },
        { no: 3, key: 'wiring_route', min: 1, title: '3.รูปแนวการเดินสายไฟจากมิเตอร์ไฟฟ้าไปถึงจุดติดตั้งตัวเครื่อง EV Charger', short: 'แนวเดินสายไฟ มิเตอร์ → เครื่องชาร์จ' },
        { no: 4, key: 'voltage_test', min: 4, title: '4.รูปทดสอบแรงดันไฟ', short: 'ทดสอบแรงดันไฟ' },
        { no: 5, key: 'wallbox_position', min: 2, title: '5.ตำแหน่งที่ติดตั้ง Wallbox ชี้จุดโดยลูกค้า/ รูปเครื่องติดตั้งโดยสมบูรณ์ โชว์สัญลักษณ์พร้อมใช้งาน ( Power on )', short: 'ตำแหน่ง Wallbox + เครื่องพร้อมใช้งาน' },
        { no: 6, key: 'terminal_torque', min: 3, title: '6.รูปการย้ำหางปลา /การขันน็อตจุดต่อเทอมมินอล /เบรกเกอร์', short: 'ย้ำหางปลา / ขันน็อตเทอมมินอล / เบรกเกอร์' },
        { no: null, key: 'extra', min: 0, title: '', short: 'รูปเพิ่มเติม (ไม่บังคับ)' },
    ],
};
// ---------- CHERY ----------
// ฟอร์มของ CHERY (`assets/ev/CHERY.pdf`, export 18 ก.พ. 2569) เป็น "เอกสารเดียวกัน" กับฟอร์ม OMODA & JAECOO
// ตรวจแล้วด้วยการวัดพิกัดคำทุกคำบนหน้า 1 ของทั้งสองไฟล์: ต่างกันไม่เกิน 0.2 pt ทุกจุด
// หัวกระดาษของไฟล์ CHERY ก็ยังพิมพ์ว่า OMODA & JAECOO (Thailand) Co., Ltd. · 7 หน้าเท่ากัน
// หัวข้อรูป 6 หัวข้อเท่ากัน ตารางสเปกแถวเดียวกัน
// จึงใช้พิกัดชุดเดียวกันทั้งหมด **แต่ยิงลงไฟล์ฟอร์มของ CHERY เอง** เผื่อค่ายรถแก้ฟอร์มแยกกันภายหลัง
// ถ้าวันหนึ่ง CHERY ส่งฟอร์มที่ layout ต่างจริง ให้เลิก clone แล้วเขียนพิกัดของตัวเองแทนที่ทั้งก้อน
export const CHERY = {
    ...OMODA_JAECOO,
    key: 'CHERY',
    label: 'CHERY',
    formPdf: 'CHERY.pdf',
    // ยังไม่มีอาร์ตเวิร์กใบรับทราบแพ็กเกจของ CHERY — ปุ่มปริ้นใบรับทราบจะตอบว่ายังไม่มีไฟล์ของค่ายนี้
    packageDoc: null,
};
export const EV_TEMPLATES = { OMODA_JAECOO, CHERY };
export const EV_TEMPLATE_KEYS = Object.keys(EV_TEMPLATES);
export function getEvTemplate(key) {
    if (!key)
        return null;
    return EV_TEMPLATES[key] ?? null;
}
/** รายการหัวข้อ + จำนวนขั้นต่ำ + ตัวเลือกของฟอร์ม สำหรับส่งให้หน้าเว็บสร้าง checklist / ฟอร์ม */
export function checklistOf(brand) {
    const t = getEvTemplate(brand);
    if (!t)
        return null;
    return {
        brand: t.key,
        label: t.label,
        hasPackageDoc: !!t.packageDoc,
        confirmSlots: t.confirm.slots.map((s) => ({ key: s.key, caption: s.caption })),
        sections: t.sections.map((s) => ({ key: s.key, no: s.no, min: s.min, short: s.short, title: s.title })),
        // ส่งตัวเลือกของฟอร์มไปให้หน้าเว็บสร้าง input เอง จะได้ไม่ต้องไปพิมพ์ตัวเลือกซ้ำในหน้าเว็บ
        // (ตัวเลือกต้องตรงกับที่ใช้วาดลง PDF เป๊ะ ไม่งั้นติ๊กแล้วไม่ขึ้นในเล่ม)
        defaultInstaller: t.defaultInstaller,
        coverOptions: {
            region: Object.keys(t.cover.checkboxes.region),
            siteType: Object.keys(t.cover.checkboxes.siteType),
        },
        spec: t.spec.rows.map((r) => ({
            key: r.key,
            label: r.label,
            multi: !!r.multi,
            freeText: !!r.freeText,
            options: r.options.map((o) => ({ value: o.value, hasFill: !!o.fill })),
        })),
    };
}
//# sourceMappingURL=ev-templates.js.map